export default "__VITE_ASSET__Bm1$aTg2__"